<template>
  <div class="cookie-badge animated fadeInUp">
  	<div>
  		<div class="close-icon" @click="setCookieData"><i class="fas fa-times fa-2x"></i></div>
  		We use cookies to enhance your experience of our websites and to enable you to register when necessary. By continuing to use this website, you agree to the use of these cookies. For more information and, please see our <router-link to="/page/cookie-policy">Cookie Policy</router-link> and our <router-link to="/page/privacy-policy">Privacy Policy</router-link>. 
	</div>
  </div>
</template>
<script>
	import { mapActions } from 'vuex'  
	export default{
		methods:{
			...mapActions(['setStateData']),
			setCookieData(){
				this.setStateData({data: true, key: 'cookie'})
			}
		}
	};
</script>
<style scoped>
	.cookie-badge{
		position:fixed;
		z-index:700;
		width:100%;
		bottom:0;
		background:rgba(0,0,0,0.8);
		padding:15px 40px 15px 5%;
		color:#FFF;
		text-align:left;
		font-weight:bold;
	}

	.close-icon{
		position:absolute;
		right:15px;
		padding:2px 8px 0px 8px;
		cursor:pointer;
	}

	
</style>
